import { render, staticRenderFns } from "./postage-detail.vue?vue&type=template&id=f3982b16&scoped=true&"
import script from "./postage-detail.vue?vue&type=script&lang=js&"
export * from "./postage-detail.vue?vue&type=script&lang=js&"
import style0 from "./postage-detail.vue?vue&type=style&index=0&id=f3982b16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3982b16",
  null
  
)

export default component.exports